<template>
    <v-app>
        <div v-scroll="onScroll">
            <nav class="top-social" v-show="exceptRoute || !isLoading">
                <div class="container">
                    <ul class="list-inline social-links">
                        <li>
                            <a
                                    @click="socialClick('Facebook')"
                                    class="facebook"
                                    href="https://www.facebook.com/magnifymyanmar/"
                                    target="_blank"
                            >
                                <i class="fab fa-facebook-f"></i>
                            </a>
                        </li>
                        <li>
                            <a
                                    @click="socialClick('Linkedin')"
                                    class="linkedin"
                                    href="https://www.linkedin.com/company/magnifymyanmar/"
                                    target="_blank"
                            >
                                <i class="fab fa-linkedin-in"></i>
                            </a>
                        </li>

                        <li class="top_cta hidden-sm-and-down">
                            <button @click="login" class="btn btn-small teal">
                                Login
                            </button>
                        </li>
                        <li class="top_cta hidden-sm-and-down">
                            <button @click="contactForm" class="form-trigger outline" data-modal="modalForm-Contact">
                                Contact
                            </button>
                        </li>
                      <li class="top_cta hidden-sm-and-down">
                        <button class="outline" @click="toFeatures">Features</button>
                      </li>
                      <li class="top_cta hidden-sm-and-down">
                        <button class="outline" @click="toWhyInsights">Why Insights</button>
                      </li>
                        <li class="top_cta hidden-sm-and-down">
                            <router-link class="form-trigger outline" tag="button" :to="{name:'index'}">Home</router-link>
                        </li>
                    </ul>
                </div>
                <v-menu
                        :min-width="500"
                        :close-on-content-click="false"
                        bottom
                        right
                        v-if="$vuetify.breakpoint.smAndDown"
                        v-model="navbarMenu"
                        transition="slide-x-transition"
                >
                    <template slot="activator" slot-scope="{on}">
                        <!-- @click="svgIconStatus" -->
                        <v-btn
                                icon
                                v-on="on"
                        >
                            <v-icon>more_vert</v-icon>
                        </v-btn>
                    </template>
                    <v-card>
                        <v-list>
                            <v-list-tile
                                    :to="{name:'index'}"
                            >
                                <v-list-tile-title>
                                    Home
                                </v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile @click="toWhyInsights">
                              <v-list-tile-title>
                                Why Insights
                              </v-list-tile-title>
                            </v-list-tile>
                          <v-list-tile @click="toFeatures">
                            <v-list-tile-title>
                              Features
                            </v-list-tile-title>
                          </v-list-tile>
                            <v-list-tile
                                    @click="contactForm"
                            >
                                <v-list-tile-title>
                                    Contact
                                </v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile
                                    @click="login"
                            >
                                <v-list-tile-title>
                                    Login
                                </v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                        <v-card-actions>
                            <v-btn
                                icon
                                @click="navbarMenu = false"
                            >
                                <v-icon>fas fa-times-circle</v-icon>
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
            </nav>
            <router-view @requestDemo="demoRequest" :iconStatus="!navbarMenu" :pagesProps="pagesProps"></router-view>
            <AppCookiePolicy></AppCookiePolicy>
            <CustomerChat/>
            <footer v-show="exceptRoute || !isLoading">
                <div class="container">
                    <div class="row">
                        <div class="footer_content">
                            <div class="links">
                                Copyright © {{copyRightYear}} Magnify Myanmar. All rights reserved
                                <br>
                                <router-link to="/terms_and_conditions" target="_blank">Terms of Service</router-link> | <router-link to="/privacy-policy" target="_blank">Privacy Policy</router-link>
                            </div>
<!--                            <div class="logo" :style="{margin: footerMargin}">-->
                            <div class="logo">
                                <a>
                                    <AppBindezFooterLogo/>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    </v-app>

</template>

<script>

	import * as ScrollMagic from 'scrollmagic';
	import {TweenMax, TimelineMax} from "gsap";
	import {ScrollMagicPluginGsap} from "scrollmagic-plugin-gsap";

	ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);

	import AppCookiePolicy from "../components/AppCookiePolicy";
	import CustomerChat from "../components/CustomerChat";
	import AppBindezFooterLogo from "../components/StaticAssets/AppBindezFooterLogo";
	export default {
		components:{
			AppBindezFooterLogo,
			CustomerChat,
			AppCookiePolicy
        },
		name: "SimpleLayout",
		data() {
			return {
				navbarMenu: false,
				iconStatus: true,
				isLoading: true,
				navScroll: false,
				getPhoneCallAwayScroll: false,
				contactMe: false,
				requestDemo: false,
				url: process.env.VUE_APP_REDIRECT_URL,
                contactPopup: undefined,
                demoPopup: undefined,
				popupOptions: {
					hideHeaders: true,
					hideFooter: true,
				}
			}
		},

		mounted() {
			this.contactPopup = window.typeformEmbed.makePopup("https://ninitun.typeform.com/to/WkxwQZtl",this.popupOptions);
			this.demoPopup = window.typeformEmbed.makePopup("https://ninitun.typeform.com/to/WkxwQZtl", this.popupOptions);
			window.setTimeout(() => {
				this.isLoading = false
			}, 4000);
		},

		methods: {
			onScroll(e) {
				let offsetTop = e.target.scrollingElement.scrollTop
				this.navScroll = offsetTop >= 216;
				this.phoneScroll = offsetTop >= 3800;
			},

			socialClick(name) {
				this.$ua.trackEvent("LandingPage", "click", name);
			},

			contactForm() {
				this.$router.push({name:'contact'});
                this.$ua.trackEvent("LandingPage", "click", "Click Contact Us");
			},

			login() {
				window.location.href = `${this.url}/login`;
				this.$ua.trackEvent("LandingPage","click","Login")
			},

      demoRequest() {
        this.demoPopup.open();
        // this.requestDemo = val
      },

      svgIconStatus() {
        this.iconStatus = !this.iconStatus;
      },

      toFeatures(){
        let {top} = document.getElementById("features").getBoundingClientRect();
        window.scrollTo({
          top: top-25,
          behavior: "smooth"
        })
      },

      toWhyInsights(){
        let {top} = document.getElementById("whyinsights").getBoundingClientRect();
        window.scrollTo({
          top: top-25,
          behavior: "smooth"
        })
      }
		},

		computed: {
			phoneScroll: {
				get() {
					return this.getPhoneCallAwayScroll
				},
				set(val) {
					this.getPhoneCallAwayScroll = val;
				}
			},

            exceptRoute(){
				return this.$route.name !== 'privacy_policy' || this.$route.name !== 'terms_of_service' || this.$route.name !== "cookie-policy"
            },

			pagesProps() {
				if (this.$route.name === "index") {
					return {
						phoneScroll: this.phoneScroll,
						isLoading: this.isLoading
					}
				}
			},

            copyRightYear(){
				return new Date().getFullYear();
            }

            // footerMargin(){
			// 	return this.$vuetify.breakpoint.smAndDown ? '0 auto' : '0 120 0 0';
            // }
		}

	}
</script>

<style scoped>
    .custom-modal-size > * > * {
        height: 500px;
    }

    button:focus {
        outline: 0;
    }
</style>
